import { ShieldCheck } from 'lucide-react'
import { AdminHeader } from '@components/layout/admin-header'
import { IntegrationsGraph } from '@components/v2/graph'
import { Tooltip } from '@components/tooltip/tooltip'
import { AllTemplatesCard } from './components/allTemplatesCard'
import { InformationCircle } from './components/informationCircle'
import { OverallCompliance } from './components/overallCompliance'
import { SubmissionsChartCard } from './components/submissionsChartCard'
import { UserActivityChartCard } from './components/userActivityChartCard'
import { TOOLTIP_INFO } from './constants'
import { useReportsErrorRateQuery } from './queries/useReportsErrorRateQuery'
import { usePageHeader } from './usePageHeader'
import { t } from '@lingui/core/macro'

export const Dashboard = () => {
  usePageHeader()

  const { data: submissionsData = {}, isLoading } = useReportsErrorRateQuery()

  return (
    <div className="h-full overflow-scroll">
      <AdminHeader>
        <AdminHeader.PageIcon>
          <ShieldCheck color="hsla(194, 47%, 20%, 1)" size={28} />
        </AdminHeader.PageIcon>
        <div className="ml-4">
          <AdminHeader.ManagerTitle>{t`Data standards`}</AdminHeader.ManagerTitle>
          <AdminHeader.Title>{t`Dashboard`}</AdminHeader.Title>
        </div>
      </AdminHeader>

      <div className="bg-[#fafafa] p-8 mb-[30px]">
        <div className="max-w-[864px] flex flex-col gap-[30px]">
          <OverallCompliance submissionsData={submissionsData} isLoading={isLoading} />
          <AllTemplatesCard />
          <UserActivityChartCard isLoading={isLoading} />
          <SubmissionsChartCard submissionsData={submissionsData} isLoading={isLoading} />
          <div>
            <div className="flex items-center gap-3 ml-4 mb-5">
              <h1 className="text-cv-blue-700 text-base font-bold">
                {t`All rows synced with integrations`}
              </h1>
              <Tooltip
                title={<p className="text-sm font-bold">{TOOLTIP_INFO.GRAPH.TITLE}</p>}
                description={<span className="text-xs">{TOOLTIP_INFO.GRAPH.DESCRIPTION}</span>}
                mode="dark"
                className="w-[383px] p-[16px]"
              >
                <InformationCircle />
              </Tooltip>
            </div>
            <IntegrationsGraph />
          </div>
        </div>
      </div>
    </div>
  )
}
